// extracted by mini-css-extract-plugin
export default {"falcon":"FalconLogo_falcon__ytOG+","eyes":"FalconLogo_eyes__7zumr","falconLook":"FalconLogo_falconLook__PyY19","falconBlink":"FalconLogo_falconBlink__5gI0m"};